import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpStatusCode
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';

/** Inject With Credentials into the request */
@Injectable()
export class CommonHttpRequestInterceptor implements HttpInterceptor {

  constructor(
    public router: Router,
  ) {

  }

  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {

    // if (req.method === 'POST' || req.method === 'PUT') {
    //   this.shiftDates(req.body);
    // }

    //this.loaderService.isLoading.next(true);

    req = req.clone({
      withCredentials: true
    });

    return next.handle(req)
      .pipe(
        catchError((error) => {
          this.handleError(error);
          return throwError(error);
        })
      )
      .pipe(
        finalize(
          () => {
            //this.loaderService.isLoading.next(false)
          }
        )
      );
  }

  private handleError(err: HttpErrorResponse): Observable<any> {

    if (err.status === Number(HttpStatusCode.Unauthorized)) {
      this.router.navigateByUrl('/login');
      //return throwError(err);
    }

    if (err.status === Number(HttpStatusCode.Forbidden)) {

    }

    return throwError(err);
  }

  shiftDates(body: any) {

    if (body === null || body === undefined) {
      return body;
    }

    if (typeof body !== 'object') {
      return body;
    }

    for (const key of Object.keys(body)) {

      const value = body[key];
      if (value instanceof Date) {
        body[key] = new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate(), value.getHours(), value.getMinutes()
          , value.getSeconds()));

      } else if (typeof value === 'object') {
        this.shiftDates(value);
      }
    };

  };
}